/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { Grid, Typography, RACModalCard, RACButton } from "@rentacenter/racstrap";
import { storeException } from "../../api/user";
import { useTranslation } from "react-i18next";
import { FeatureFlagContext } from "../../context/FeatureFlagContext";


interface storeExceptionInterFace {
    refCode?: any;
    identifierId?: any;
    storeExceptionCancelled?: any
    storeExceptionCompleted?: any
    identifierType?: any
    isopen?: any
    setStoreExceptionEnable?: any
    exceptionDescscription?: any

}
export default function StoreException(props: storeExceptionInterFace) {

 const {i18n, t}= useTranslation('split');
 const {featureFlagDetails}= useContext(FeatureFlagContext);

    const { refCode, identifierId, storeExceptionCancelled, storeExceptionCompleted, identifierType, exceptionDescscription } = props

    const [storeExceptionPopup, setStoreExceptionPopup] = React.useState(true)
    let [exceptionText, SetexceptionText] = React.useState('')
    let [remainingLength, setremainingLength] = React.useState(255)
    let [exceptionDesc, setexceptionDesc] = React.useState('')
    const exceptionTextEnterFn = (inputText: any) => {
        exceptionText = inputText
        SetexceptionText(inputText)

        remainingLength = 255 - exceptionText.length
        setremainingLength(remainingLength)

    }
    const setStoreExceptionCancelClick = async () => {
    props.setStoreExceptionEnable(false)


        storeExceptionCancelled()
        exceptionText = ''
        SetexceptionText(exceptionText)
        exceptionDesc = ''
        setexceptionDesc(exceptionDesc)
        remainingLength = 255
        setremainingLength(remainingLength)
    }
    const setStoreExceptionCompletedClick = async () => {
        // debugger
        props.setStoreExceptionEnable(false)

        const payload = {
         storeException: [
                {
                    identifierId: identifierId,
                    identifierType: identifierType,
                    storeNumber: window.sessionStorage.getItem('storeNumber'),
                    exceptionTypeRefCode: refCode,
                    exceptionText: exceptionText
                }
            ]
        }
        const storeExceptionRes = storeException(payload)
        storeExceptionCompleted()
        exceptionText = ''
        SetexceptionText(exceptionText)
        exceptionDesc = ''
        setexceptionDesc(exceptionDesc)
        remainingLength = 255
        setremainingLength(remainingLength)

    }
    const StoreExceptionPopup = () => {
        return (
            <>
                <Typography style={{ marginTop: '10px' }}>
                    {t("Explanation")} <span style={{ color: 'red' }}> *</span>
                </Typography>
                <textarea
                    value={exceptionText}
                    rows={8}
                    cols={73}
                    maxLength={255}
                    onChange={(e: any) => {
                        exceptionTextEnterFn(e.target.value.trimStart())

                    }}
                    style={{ resize: 'none', borderRadius: '5px', marginTop: '5px', padding: '5px' }}
                >
                </textarea>
                <span style={{ marginTop: '15px', fontFamily: 'OpenSans-semibold', color: '#00000085' }}>{remainingLength}{t("/255 characters left.")}</span>
                <Grid style={{ float: 'right', marginTop: '34px' }}>
                    <RACButton
                        style={{ marginRight: '10px' }}

                        color='default'
                        variant='outlined'
                        disabled={false}
                        onClick={() => setStoreExceptionCancelClick()}
                    >
                        {t("Cancel")}
                    </RACButton>
                    <RACButton
                        style={{ marginRight: '35px' }}
                        color='primary'
                        variant='contained'
                        disabled={exceptionText?.length > 0 ? false : true}
                        onClick={() => { setStoreExceptionCompletedClick() }}
                    >
                        {t("Save")}
                    </RACButton>
                </Grid>
            </>
        )
    }
    return (
        <Grid>
            <RACModalCard
                title={`${t("Enter Explanation for")} ${t(exceptionDescscription)} ${featureFlagDetails.MXStoreIdentifier == "0" ? t("Exception") : ''}`}
                isOpen={props.isopen}
                closeIcon={true}
                maxWidth="sm"
                onClose={() => setStoreExceptionCancelClick()}
                borderRadius={"25px !important"}
                children={StoreExceptionPopup()}
            />
        </Grid>
    )
}